export enum AlertStatus {
  Open,
  Lowered,
}
